/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import { AccountDetails } from "./account-details"
import { ChangePassword } from "./change-password"
import { TotpSetup } from "./totp-setup"

export const UserSettingsView = () => (
    <div className="w-content">
        <h1 className="m-0 mb-6 text-3xl font-bold text-primary">Settings</h1>

        <div className="grid max-w-125 gap-6">
            <AccountDetails />
            <ChangePassword />
            <TotpSetup />
        </div>
    </div>
)
